import { useQuery } from 'urql';
import { schoolPageBySlugTabContentQuery } from './schoolPageBySlugTabContentQuery';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { useSchoolIdContext } from '../../contexts/SchoolIdContext/SchoolIdContext';
import { formatChildPath, formatPathnameToSchoolSlug } from '../helpers/formatPathnameToSchoolSlug';
import { Variables } from '../types';

export const useSchoolTabContentQueryVariables = () => {
  const { url, childPath } = useUrlContext();
  const schoolId = useSchoolIdContext();

  const vars = {
    id: schoolId,
    slug: formatPathnameToSchoolSlug(url.pathname, childPath),
    path: formatChildPath(childPath),
    imageFormatWebp: 'WEBP',
    page: 1,
  } satisfies Variables;

  return vars;
};

export const useSchoolPageBySlugTabContentQuery = () => {
  const [result] = useQuery({
    query: schoolPageBySlugTabContentQuery,
    variables: useSchoolTabContentQueryVariables(),
  });

  return result;
};
